import React from 'react';

const BannerSlider = () => {
    return (
        <>
            <div id="my-carousel" class="carousel slide carousel-fade" data-ride="carousel" data-interval="5000">
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <a href="http://sh.st/st/4152f4bc9d1aca5236b3ab14a650a949/publish0x.com/?a=3YaO7Jkgax" target="_blank" rel="noreferrer">
                            <img class="d-block w-100" src="https://cdn.publish0x.com/prod/fs/images/33c269faba15539b6d471ae97bb5fea577e2128fc361d36a4ab233eaba166d8e.gif" width="100%" alt="publish0x.com"/>
                        </a>
                    </div>
                    <div class="carousel-item">
                        <a href="http://sh.st/st/4152f4bc9d1aca5236b3ab14a650a949/pipeflare.io/r/40bx" target="_blank" rel="noreferrer">
                            <img class="d-block w-100" src="./images/Pipeflare-promo-banner_728x90.jpg" width="100%" alt="Pipeflare.io"/>
                        </a>
                    </div>
                    <div class="carousel-item">
                        <a href="http://sh.st/st/4152f4bc9d1aca5236b3ab14a650a949/vilton.ltd/partner/viltonzaiss" target="_blank" rel="noreferrer">
                            <img class="d-block w-100" src="https://vilton.ltd/assets/img/a/long_en.gif" width="100%" alt="Vilton.ltd"/>
                        </a>
                    </div>
                    <div class="carousel-item">
                        <a href="http://sh.st/st/4152f4bc9d1aca5236b3ab14a650a949/vixes.biz/?ref=pMehoM" target="_blank" rel="noreferrer">
                            <img class="d-block w-100" src="https://vixes.biz/media/banners/vixes728x90.gif" width="100%" alt="Vixes.biz"/>
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
};

export default BannerSlider;
